module.exports = __webpack_public_path__ + "img/4. Reduced prices-th.d8f6d37.png";